const pendingSaveTimestamp = (opportunity) => {
  const value = opportunity?.updatedAt ?? opportunity?.createdAt;
  const timestamp = value ? Date.parse(value) : Number.NaN;
  return Number.isFinite(timestamp) ? timestamp : 0;
};

// The pending-saves endpoint contract is a bare array of save-damage resolutions.
export function normalizePendingSaveResponse(value) {
  if (!Array.isArray(value)) return [];

  return value
    .filter((resolution) =>
      resolution?.status === 'prepared' &&
      resolution?.targetSave?.status === 'awaiting-response'
    )
    .sort((left, right) => {
      const timestampDifference = pendingSaveTimestamp(right) - pendingSaveTimestamp(left);
      if (timestampDifference) return timestampDifference;
      const revisionDifference = Number(right?.combatRevision ?? -1) - Number(left?.combatRevision ?? -1);
      if (revisionDifference) return revisionDifference;
      return String(right?._id ?? right?.resolutionId ?? '')
        .localeCompare(String(left?._id ?? left?.resolutionId ?? ''));
    });
}

